import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as api from "./api";
import type { CreateOverridePayload, TaskNotificationChannelOverride, UpdateOverridePayload } from "./types";

export const overrideKeys = {
  all: ["taskNotificationChannelOverrides"] as const,
  lists: () => [...overrideKeys.all, "list"] as const,
};

export function useOverridesQuery() {
  return useQuery<TaskNotificationChannelOverride[]>({
    queryKey: overrideKeys.lists(),
    queryFn: api.fetchOverrides,
    staleTime: 1000 * 60 * 3,
  });
}

export function useCreateOverride() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateOverridePayload) => api.createOverride(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: overrideKeys.all });
    },
  });
}

export function useUpdateOverride() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: UpdateOverridePayload }) => api.updateOverride(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: overrideKeys.all });
    },
  });
}

export function useDeleteOverride() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.deleteOverride(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: overrideKeys.all });
    },
  });
}
